module.exports = __webpack_public_path__ + "img/icon_full_en_shadow.13e1f465.png";